export const NOTIFICATION_TYPES = {
  PROPOSAL: 'proposal',
  MESSAGE: 'message',
  PENDING: 'Pending',
  ACCEPTED: 'Accepted',
  DECLINED: 'Declined',
  IGNORED: 'Ignored',
};

export const DEADLINE_STATUS = {
  EXPIRED: 'Expired',
};

export const NOTIFICATION_TABS = [
  { id: 'All', label: 'All', value: 'All' },
  { id: 'Pending', label: 'Pending', value: 'Pending' },
  { id: 'Accepted', label: 'Accepted', value: 'Accepted' },
  { id: 'Declined', label: 'Declined', value: 'Declined' },
  { id: 'Ignored', label: 'Ignored', value: 'Ignored' },
];
